import { CircleUser } from "lucide-react";
import { usePostHog } from "posthog-js/react";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSignOut } from "@/hooks/useSignOut";
import { useStoreUser } from "@/hooks/useStoreUser";
import { auth } from "@/services/config";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { ChangePasswordDialog } from "./changePasswordDialog";

export const AccountDropdown = () => {
  const { t } = useTranslation();
  const { user } = useStoreUser();
  const { logout } = useSignOut();
  const posthog = usePostHog();

  const [changePasswordDialogOpen, setChangePasswordDialogOpen] =
    useState(false);

  const isEmailPasswordUser = useMemo(() => {
    const currentUser = auth.currentUser;
    if (!currentUser) return false;

    return currentUser.providerData.some(
      (provider) => provider.providerId === "password",
    );
  }, [auth.currentUser]);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="icon" className="rounded-full">
            <CircleUser className="h-5 w-5" />
            <span className="sr-only">Toggle user menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-39">
          <DropdownMenuItem disabled>{user.email}</DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => posthog.capture("feedback_click")}>
            {t("feedback")}
          </DropdownMenuItem>
          {isEmailPasswordUser && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={() => setChangePasswordDialogOpen(true)}
              >
                {t("change_password")}
              </DropdownMenuItem>
            </>
          )}
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => logout()} className="font-semibold">
            {t("signout")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ChangePasswordDialog
        open={changePasswordDialogOpen}
        onOpenChange={setChangePasswordDialogOpen}
      />
    </>
  );
};
